<template>
  <div class="permission-init-error">
    <v-container>
      <v-row justify="center" align="center">
        <v-col cols="12" md="8" class="text-center">
          <v-icon color="error" large>mdi-alert</v-icon>
          <h1>Permission Initialization Failed</h1>
          <p>
            We were unable to load your permissions. This may be due to a network issue or a problem with the server.<br>
            Please try refreshing the page, or contact support if the problem persists.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PermissionInitError',
};
</script>

<style scoped>
.permission-init-error {
  margin-top: 80px;
}
</style> 